import React from 'react';
import PropTypes from 'prop-types';

import { phonePropType } from 'config/propTypes';

import { YourStorageUnitCard } from './YourStorageUnitCard';
import { CreditCardsCard } from './CreditCardsCard';
import { YourStorageFacilityCard } from './YourStorageFacilityCard';

import './UnitSidebar.scss';

export function UnitSidebar({ facility, unit, phone }) {
	return (
		<div className="unit-sidebar">
			<YourStorageUnitCard unit={unit} />
			{!!facility.acceptedCreditCards.length && (
				<CreditCardsCard cards={facility.acceptedCreditCards} />
			)}
			<YourStorageFacilityCard
				facility={facility}
				phone={phone}
			/>
		</div>
	);
}

UnitSidebar.propTypes = {
	facility: PropTypes.object,
	unit: PropTypes.object,
	phone: phonePropType,
};

export default UnitSidebar;
